import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearLiveTrackingToasts,
  dismissLiveTrackingToast,
  setLiveTrackingPendingOpen,
} from '../../store/slices/liveTrackingSlice';

const LiveTrackingAlertToast = () => {
  const dispatch = useDispatch();
  const toasts = useSelector((state) => state.liveTracking?.toasts || []);
  if (!toasts.length) return null;

  const latest = toasts[0];
  const count = toasts.length;
  const line = latest.kind === 'COMMENT'
    ? `${latest.actorName ? `${latest.actorName}: ` : ''}${latest.body}`
    : latest.body;

  const openToast = (toast) => {
    dispatch(setLiveTrackingPendingOpen(toast.itemId));
    dispatch(dismissLiveTrackingToast(toast.id));
    window.dispatchEvent(new CustomEvent('workloop:open-live-tracking', {
      detail: {
        itemId: toast.itemId,
        itemType: toast.itemType,
        taskId: toast.taskId,
        sourceMessageId: toast.sourceMessageId,
      },
    }));
  };

  return (
    <div className="fixed bottom-6 right-5 z-[4100] pointer-events-none">
      <div className="pointer-events-auto relative w-[360px] overflow-hidden rounded-[22px] border border-white/20 bg-gradient-to-b from-slate-900/95 to-slate-950/95 text-white shadow-[0_24px_60px_rgba(15,23,42,0.55)]">
        <div className="live-tracking-blink absolute inset-0 rounded-[22px]" />
        <div className="relative z-10">
          <button
            type="button"
            onClick={() => openToast(latest)}
            className="flex w-full items-center gap-3 px-4 py-3 text-left"
          >
            <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-fuchsia-500 to-amber-400 text-sm font-bold">
              {count}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-[11px] font-bold uppercase tracking-wide text-amber-200">
                {latest.kind === 'COMMENT' ? 'New comment' : 'Status update'} · Live Tracking
              </span>
              <span className="mt-0.5 block truncate text-[14px] font-semibold leading-5">
                {latest.title}
              </span>
              <span className="mt-0.5 block truncate text-[12px] text-white/80">
                {line}
              </span>
            </span>
          </button>
          <button
            type="button"
            onClick={() => dispatch(clearLiveTrackingToasts())}
            className="absolute right-3 top-3 rounded-full border border-white/15 bg-white/10 px-2 py-0.5 text-[11px] font-semibold text-white/90 hover:bg-white/20"
          >
            Hide
          </button>
          {count > 1 ? (
            <div className="max-h-48 overflow-y-auto border-t border-white/10 bg-black/25">
              {toasts.map((toast) => (
                <div key={toast.id} className="flex items-stretch border-b border-white/10 last:border-b-0">
                  <button
                    type="button"
                    onClick={() => openToast(toast)}
                    className="min-w-0 flex-1 px-4 py-2 text-left text-[13px]"
                  >
                    <span className="block truncate font-semibold">{toast.title}</span>
                    <span className="block truncate text-[12px] text-white/70">
                      {toast.kind === 'COMMENT' ? toast.body : 'Status or details updated'}
                    </span>
                  </button>
                  <button
                    type="button"
                    onClick={() => dispatch(dismissLiveTrackingToast(toast.id))}
                    className="w-9 text-white/40 hover:text-white"
                    aria-label="Dismiss"
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default LiveTrackingAlertToast;
